
import React from 'react';
import { Check, Book, Brain, Lightbulb, Bot, Sparkles, Code, Palette, GraduationCap } from 'lucide-react';

const BenefitsList = () => {
  const benefits = [
    {
      text: "A massive head start in the most important skill of the next 20 years",
      icon: <Sparkles className="h-5 w-5 text-pink-500" />,
      bg: "bg-pink-100"
    },
    {
      text: "The confidence to think, speak, and create independently using AI",
      icon: <Brain className="h-5 w-5 text-purple-500" />,
      bg: "bg-purple-100"
    },
    {
      text: "Real-world skills like writing, designing, and presenting — all made fun",
      icon: <Palette className="h-5 w-5 text-blue-500" />,
      bg: "bg-blue-100"
    },
    {
      text: "Tools they can use at home to finish homework faster and smarter",
      icon: <Bot className="h-5 w-5 text-green-500" />,
      bg: "bg-green-100"
    },
    {
      text: "The ability to build and lead projects, not just follow instructions",
      icon: <GraduationCap className="h-5 w-5 text-orange-500" />,
      bg: "bg-orange-100"
    }
  ];

  return (
    <div className="space-y-8">
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 to-purple-600">
        What Your Child Will Walk Away With:
      </h2>
      
      <div className="space-y-6">
        {benefits.map((benefit, index) => (
          <div 
            key={index} 
            className="flex items-start bg-white p-4 rounded-lg shadow-md border-l-4 border-purple-500 hover:transform hover:scale-105 transition-transform duration-200"
          >
            <div className={`flex-shrink-0 h-10 w-10 rounded-full ${benefit.bg} flex items-center justify-center mr-3 shadow-inner`}>
              {benefit.icon}
            </div>
            <div className="flex items-center">
              <Check className="h-4 w-4 text-purple-600 mr-2 flex-shrink-0" />
              <p className="text-lg font-medium">{benefit.text}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="bg-gradient-to-r from-purple-50 to-pink-50 border-2 border-purple-200 p-6 rounded-lg text-center shadow-inner">
        <p className="text-lg text-purple-800 font-bold">
          Because your child deserves more than just "keeping up" — they deserve to lead.
        </p>
      </div>
    </div>
  );
};

export default BenefitsList;
